module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_7.998b6f26.jpg";